/* globals angular, twttr */

(function () {
  var module = angular.module('ace.apiService', []);

  module.run([
    '$http',
    'appConfig',
    function ApiConfig($http, appConfig) {
      $http.defaults.headers.common['X-Api-Token'] = appConfig.apiToken;
    },
  ]);

  module.factory('ApiService', [
    '$q',
    '$http',
    'appConfig',
    function ApiService($q, $http, appConfig) {
      var service = {};

      var flattenValues = function (docs) {
        if (!angular.isArray(docs)) {
          return docs;
        }

        return docs.map(function (doc) {
          if (doc && doc.fields) {
            angular.forEach(doc.fields, function (field, fieldSlug) {
              doc.fields[fieldSlug] = flattenValues(field.value);
            });
          }
          if (doc && doc.parents) {
            doc.parents = flattenValues(doc.parents);
          }
          return doc;
        });
      };

      // Custom serializer for Lambda
      var paramSerializer = function (params) {
        var paramsArray = [];

        angular.forEach(params, function (value, key) {
          if (angular.isArray(value)) {
            value.forEach(function (v, i) {
              paramsArray.push(key + '[' + i + ']=' + v);
            });
          } else if (value !== null && value !== undefined) {
            paramsArray.push(key + '=' + value);
          }
        });

        return encodeURI(paramsArray.join('&'));
      };

      service.metadata = function () {
        return $q(function (resolve, reject) {
          $http
            .get(appConfig.apiUrl + '/metadata.json', {
              cache: true,
            })
            .then(function (response) {
              resolve(response.data);
            })
            .catch(reject);
        });
      };

      service.entitySearch = function (params) {
        var defaultParams = {
          q: '*:*',
          sort: '-<score>',
          limit: 200,
          include_docs: false,
          children: false,
          parents: false,
        };

        return $q(function (resolve, reject) {
          params = angular.extend({}, defaultParams, params);

          $http
            .get(appConfig.apiUrl + '/entities/search.json', {
              params: params,
              paramSerializer: paramSerializer,
              cache: true,
            })
            .then(function (response) {
              var result = response.data;

              if (result.rows) {
                result.rows = result.rows.map(function (row) {
                  return row.doc;
                });

                result.rows = flattenValues(result.rows);
              } else if (result.groups) {
                result.groups = result.groups.map(function (group) {
                  group.rows = group.rows.map(function (row) {
                    return row.doc;
                  });

                  group.rows = flattenValues(group.rows);

                  return group;
                });
              }

              resolve(result);
            })
            .catch(reject);
        });
      };

      service.entitySearchOne = function (params) {
        return service.entitySearch(params).then(function (result) {
          return result.rows.length ? result.rows[0] : {};
        });
      };

      service.entityFind = function (params) {
        return $q(function (resolve, reject) {
          var defaultParams = {
            query: {},
            children: false,
            parents: false,
          };

          $http
            .get(appConfig.apiUrl + '/entities/find.json', {
              params: angular.extend(defaultParams, params),
              paramSerializer: paramSerializer,
              cache: true,
            })
            .then(function (response) {
              response.data.docs = flattenValues(response.data.docs);

              resolve(response.data);
            })
            .catch(reject);
        });
      };

      service.entityById = function (params) {
        return $q(function (resolve, reject) {
          var defaultParams = {
            ids: [],
            children: false,
            parents: false,
          };

          $http
            .get(appConfig.apiUrl + '/entities.json', {
              params: angular.extend(defaultParams, params),
              paramSerializer: paramSerializer,
              cache: true,
            })
            .then(function (response) {
              resolve(flattenValues(response.data));
            })
            .catch(reject);
        });
      };

      service.entityByIdOne = function (params) {
        params.ids = [params.id];
        delete params.id;

        return service.entityById(params).then(function (results) {
          return results.length ? results[0] : {};
        });
      };

      service.getEntityIds = function (entities) {
        return entities.map(function (entity) {
          return entity.id;
        });
      };

      service.taxonomy = function (taxonomySlug) {
        return $q(function (resolve, reject) {
          $http
            .get(appConfig.apiUrl + '/taxonomy.json', {
              params: {
                taxonomySlug: taxonomySlug,
              },
              paramSerializer: paramSerializer,
              cache: true,
            })
            .then(function (response) {
              resolve(response.data[taxonomySlug]);
            })
            .catch(reject);
        });
      };

      service.socialTwitter = function (endpoint, params) {
        return $q(function (resolve, reject) {
          $http
            .get(appConfig.apiUrl + '/social/twitter/get/' + endpoint, {
              params: params || {},
              paramSerializer: paramSerializer,
              cache: true,
            })
            .then(function (response) {
              var result = response.data.map(function (tweet) {
                tweet.text = twttr.txt.autoLink(
                  twttr.txt.htmlEscape(tweet.text)
                );
                tweet.created_at = Date.parse(tweet.created_at);

                return tweet;
              });

              resolve(result);
            })
            .catch(reject);
        });
      };

      service.socialInstagram = function (endpoint, params) {
        return $q(function (resolve, reject) {
          $http
            .get(appConfig.apiUrl + '/social/instagram/get/' + endpoint, {
              params: params || {},
              paramSerializer: paramSerializer,
              cache: true,
            })
            .then(function (response) {
              resolve(response.data);
            })
            .catch(reject);
        });
      };

      return service;
    },
  ]);
})();
